export const GlobalSetting = {
  CUSTOMER_CARD_VALIDITY: 'CUSTOMER_CARD_VALIDITY',
  EWalletMinRecharge: 'E_WALLET_MIN_RECHARGE', // in cents
  EWalletMaxRecharge: 'E_WALLET_MAX_RECHARGE', // in cents
  EWalletMaxAmount: 'E_WALLET_MAX_AMOUNT', // in cents
  MaxDaysBeforeTicketValidFrom: 'MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_ESHOP', // in days
  MaxDaysAfterTicketValidFrom: 'MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_AFTER_START_AT_ESHOP', // in days
};
